import { render, staticRenderFns } from "./PedidoCuentaList.vue?vue&type=template&id=7564584d"
import script from "./PedidoCuentaList.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports